import {useNavigate} from "react-router-dom";
import {isNullOrUndefined} from "../../services/Validator";
import {kSystemIcons} from "../../constants/icons";
import SystemNavigationItemIcon from "../icons/SystemNavigationItemIcon";
import SystemNavigationItemName from "../others/SystemNavigationItemName";
import {kSystemDrawerNavText} from "../../constants/texts";

export default function SystemDrawerNavigationItem({item, isActive}) {
    // Used in SystemTopBarNavigation to display
    // side navigation items

    // PROPERTIES
    let navigate = useNavigate()

    // BUILD
    if (isNullOrUndefined(item) || isNullOrUndefined(item.name) || isNullOrUndefined(item.route))
        return null
    return(
        <div className={`relative overflow-hidden group bg-transparent py-[16px] min-h-[56px] select-none
                        ${isActive ? `cursor-default border-l-[2px] ${item.name === kSystemDrawerNavText.brevet ? "border-greenStar" : "border-primary"}  text-white`
                                   : `cursor-pointer border-l border-transparent text-greyLight9 hover:text-white hover:border-l-[2px] ${item.name === kSystemDrawerNavText.brevet ? "hover:border-greenStar" : "hover:border-primary"}`}`}
             onClick={isActive ? null : () => navigate(item.route)}>
            <div className={"w-full flex justify-between items-center relative z-10 pl-[16px] pr-[10px]"}>
                <div className={"w-full flex justify-start items-center space-x-[12px] font-normal"}>
                    <SystemNavigationItemIcon icon={item.icon} />
                    <SystemNavigationItemName name={item.name} />
                </div>
                <i className={`material-icons text-[24px]`}>
                    {kSystemIcons.chevronRight}
                </i>
            </div>
            <div className={`absolute inset-0 opacity-0 group-hover:opacity-30
                            bg-gradient-to-r ${item.name === kSystemDrawerNavText.brevet ? "from-[rgba(114,206,159,0.55)]" : "from-[rgba(48,174,247,0.55)]"} to-[rgba(255,255,255,0)]
                            ${isActive ? "opacity-30" : ""}`}>
            </div>
        </div>
    );
}